import { render, staticRenderFns } from "./ThgRegistrationAtUploadCard.vue?vue&type=template&id=463437d2"
import script from "./ThgRegistrationAtUploadCard.vue?vue&type=script&lang=ts"
export * from "./ThgRegistrationAtUploadCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports